import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(
	{
		root: {
			width: '100%',
			height: 350,
			boxShadow: 'none'
		},
		content: {
			textAlign: 'left',
			paddingLeft: 0,
			paddingRight: 0
		},
  		iconRoot: {
			textAlign: 'center'
		},
		titleText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 16,
			fontWeight: 600,
			letterSpacing: 0,
			marginTop: 10
		},
		dateText: {
			color: '#5E6366',
			fontFamily: 'Graphik',
			fontSize: 15,
			fontWeight: 500,
			letterSpacing: 0,
			marginTop: 5,
		},
		media: {
			height: 250,
			width: '100%'
		},
		rootLink: {
			'&:hover': {
			textDecoration: 'none',
		}
  },
	}
);

const RecentStoryCard = ( { link, imageURL, title, storyDate } ) => {
	const classes = useStyles();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up('sm'));

	return (
		<Card className={classes.root}>
			<CardActionArea className={classes.rootLink} href={link} >
			<CardContent className={classes.content}>
				<CardMedia
					className={classes.media}
					image={imageURL}
				/>
				<Typography className={classes.titleText}
				style={(matches)?{fontSize: 15}:{fontSize: 12}}>
					{title}
				</Typography>
				<Typography className={classes.dateText}
				style={(matches)?{fontSize: 16}:{fontSize: 12}}>
					{storyDate}
				</Typography>
        	</CardContent>
			</CardActionArea>
		</Card>
	)
}

RecentStoryCard.propTypes = {
  imageURL: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  storyDate: PropTypes.string.isRequired
};

export default RecentStoryCard;
